import { useMemo } from "react";
import resolveResponsiveStyleProp from "../resolveResponsiveStyleProp";
import resolveStylePropValue from "../resolveStylePropValue";
export default function useStyle(props) {
    const { styleProps, tokens, getToken, stylePropsMap } = props;
    const style = useMemo(() => {
        const resolvedStyles = Object.keys(styleProps).reduce((acc, key) => {
            const { property } = stylePropsMap[key];
            const value = styleProps[key];
            // Breakpoint maps resolve to one var per breakpoint
            if (typeof value === "object") {
                return {
                    ...acc,
                    ...resolveResponsiveStyleProp({
                        value,
                        config: stylePropsMap[key],
                        tokens,
                        getToken,
                    }),
                };
            }
            return {
                ...acc,
                [property]: resolveStylePropValue({
                    value,
                    config: stylePropsMap[key],
                    tokens,
                    getToken,
                }),
            };
        }, {});
        return resolvedStyles;
    }, [styleProps, tokens, getToken, stylePropsMap]);
    return style;
}
//# sourceMappingURL=useStyle.js.map